import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import cookie from '@snapask/common-components/dist/utils/cookie';

import {
  types,
  fetchPracticeSubjectsFailure,
  fetchPracticeSubjectsSuccess,
  fetchSubjectConceptsFailure,
  fetchSubjectConceptsSuccess,
  fetchPracticeConceptFailure,
  fetchPracticeConceptSuccess,
  fetchPracticeQuizzesSuccess,
  fetchPracticeQuizzesFailure,
  getQuizzes,
} from '@blueberry/redux/practice';

import {
  SHOW_DASHBOARD_PRACTICE_CONCEPTS,
  PRACTICE_TUTORIAL_STAGE,
} from '@blueberry/constants/cookieNames';
import {
  QUIZ_STAGE_COUNT,
  QUIZ_STAGE_LOCATION_COUNT,
} from '@blueberry/constants/praticeQuizStage';

import {
  getPracticeSubjects,
  getPracticeConcepts,
  getConceptDetail,
  getConceptQuizzies,
  postPracticeQuizziesResult,
} from '@blueberry/services/apis';

import config from '@blueberry/config';

import { getRandomValue, getLocationIndex } from './practiceUtils';

const stageWidth = 100 / QUIZ_STAGE_COUNT;
const locationHeight = 100 / QUIZ_STAGE_LOCATION_COUNT;

export function* fetchPracticeSubjectsFlow() {
  try {
    const { subjects: source } = yield call(getPracticeSubjects);
    // for align the school subject schema
    const subject = source.map(p => ({ ...p, description: p.name }));
    const { id: selectedSubjectId } = subject[0] || {};

    yield put(fetchPracticeSubjectsSuccess(subject, selectedSubjectId));
  } catch (err) {
    yield put(fetchPracticeSubjectsFailure(err));
  }
}

export function* viewStartPageFlow() {
  const snapCookie = new cookie(config.COOKIE_DOMAIN);
  snapCookie.setCookie(SHOW_DASHBOARD_PRACTICE_CONCEPTS, true);
}

export function* calculateConceptPosition(sourceConcepts) {
  const starLocationOfStages = Array.from({ length: 13 }).map(() =>
    new Array(6).fill(true)
  );

  const concepts = sourceConcepts.reduce((acc, concept) => {
    const isOdd = concept.stage % 2 === 1;
    const stageLocations = starLocationOfStages[concept.stage];

    const locationIndex = getLocationIndex(stageLocations);
    const top = (locationIndex * 2 + (isOdd ? 1 : 0)) * locationHeight;
    // random the left in one stage
    const left = stageWidth * concept.stage + getRandomValue(stageWidth);
    stageLocations[locationIndex] = false;

    acc.push({
      ...concept,
      position: {
        left: `${left}%`,
        top: `${top}%`,
      },
    });

    return acc;
  }, []);

  return concepts;
}

export function* fetchSubjectConceptsFlow(action) {
  try {
    const { id } = action.payload;
    const { concepts: conceptsResp, concept_count: levels } = yield call(
      getPracticeConcepts,
      id
    );

    const concepts = yield call(calculateConceptPosition, conceptsResp);

    yield put(fetchSubjectConceptsSuccess({ concepts, levels }));
  } catch (err) {
    yield put(fetchSubjectConceptsFailure(err));
  }
}

export function* fetchPracticeConceptFlow(action) {
  try {
    const { id } = action.payload;
    const { concept } = yield call(getConceptDetail, id);

    yield put(fetchPracticeConceptSuccess(concept));
  } catch (err) {
    yield put(fetchPracticeConceptFailure(err));
  }
}

export function* fetchPracticeQuizzesFlow(action) {
  try {
    const { conceptId } = action.payload;

    const { quizzes } = yield call(getConceptQuizzies, conceptId);

    yield put(fetchPracticeQuizzesSuccess(quizzes));
  } catch (err) {
    yield put(fetchPracticeQuizzesFailure(err));
  }
}

export function* changePracticeTutorialStageFlow(action) {
  const { stage } = action.payload;

  const snapCookie = new cookie(config.COOKIE_DOMAIN);
  snapCookie.setCookie(PRACTICE_TUTORIAL_STAGE, stage);
}

export function* finishPracticeQuizziesFlow(action) {
  try {
    const { id } = action.payload;
    const quizzes = yield select(getQuizzes);

    const result = quizzes.map(quiz => ({
      qz_id: quiz.qz_id,
      student_answer: quiz.selectedAnswer,
    }));

    const data = {
      concept_id: id,
      quizzes: result,
    };

    yield call(postPracticeQuizziesResult, data);
  } catch (err) {
    // no need handle if error
  }
}

export default function*() {
  yield all([
    takeLatest(types.FETCH_PRACTICE_SUBJECTS, fetchPracticeSubjectsFlow),
    takeLatest(types.VIEW_CONCEPTS_PAGE, viewStartPageFlow),
    takeLatest(types.FETCH_RPACTICE_SUBJECT_CONCEPTS, fetchSubjectConceptsFlow),
    takeLatest(types.FETCH_PRACTICE_CONCEPT, fetchPracticeConceptFlow),
    takeLatest(types.FETCH_PRACTICE_QUIZZES, fetchPracticeQuizzesFlow),
    takeLatest(
      types.CHANGE_PRACTICE_TUTORIAL_STAGE,
      changePracticeTutorialStageFlow
    ),
    takeLatest(types.FINISH_PRACTICE_QUIZZES, finishPracticeQuizziesFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/practice.js